// import React, { useMemo, useState } from 'react';
// import { Box, Button } from '@mui/material';
// import ModalForms from '../../Shared/Modals/index.js';
// import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
// import { LeadFormActions } from '../../../Services/_actions/index.js';
// import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
// import { useRecoilState, useRecoilValue } from 'recoil';
// import { leadsTableStateAtom } from '../../../Services/_states/index.js';

// interface Props {
//   open: boolean;
//   onClose: () => void;
//   typeOfStatusList: Record<string, any[]>;
//   onSuccess?: () => void;
//   selectedRow?: any;
//   campaignId: string;
// }

// type SelectionState = Record<
//   string,
//   {
//     status: any | null;
//     subStatus: any | null;
//   }
// >;

// const StatusSubStatusModal: React.FC<Props> = ({
//   open,
//   onClose,
//   typeOfStatusList,
//   selectedRow,
//   onSuccess,
//   campaignId,
// }) => {
//   const leadActions = LeadFormActions();
//   const { showSnackBar } = useSnackBar();
//   const [selectionMap, setSelectionMap] = useState<SelectionState>({});
//   const [loading, setLoading] = useState(false);
//   const tableState = useRecoilValue<any>(leadsTableStateAtom);
// console.log("typeOfStatusList0000:", typeOfStatusList);
//   const typeOptions = useMemo(() => {
//     return typeOfStatusList ? Object.keys(typeOfStatusList) : [];
//   }, [typeOfStatusList]);

//   const isSubStatusType = (type: string) => {
//     const list = typeOfStatusList[type] || [];
//     return list.some((item) => item?.sub_status_id);
//   };

//   const getStatusOptions = (type: string) => {
//     const list = typeOfStatusList[type] || [];
//     // Status list = items WITHOUT sub_status_id
//     return list.filter((item) => !item?.sub_status_id);
//   };

//   const getSubStatusOptions = (type: string) => {
//     const list = typeOfStatusList[type] || [];
//     // Sub status list = items WITH sub_status_id
//     return list.filter((item) => item?.sub_status_id);
//   };

//   const handleStatusChange = (type: string, status: any) => {
//     setSelectionMap((prev) => ({
//       ...prev,
//       [type]: { status, subStatus: null },
//     }));
//   };

//   const handleSubStatusChange = (type: string, subStatus: any) => {
//     setSelectionMap((prev) => ({
//       ...prev,
//       [type]: { ...prev[type], subStatus },
//     }));
//   };

//   const getLeadIds = () => {
//     if (!selectedRow) return [];
//     if (Array.isArray(selectedRow)) return selectedRow.map((r) => r?.id).filter(Boolean);
//     return selectedRow?.id ? [selectedRow.id] : [];
//   };

//   const buildStatusData = () => {
//     return typeOptions
//       .filter((type) => selectionMap[type]?.status)
//       .map((type) => {
//         const status = selectionMap[type]?.status;
//         const subStatus = selectionMap[type]?.subStatus;
// // console.log("status, subStatus:", status, subStatus);
// // console.log("selectionMap:", selectionMap);
//         const baseObj: any = {
//           type_of_status: type,
//           status_id: status?.status_id,
//           status_name: status?.status_name || status?.alias_name,
//         };

//         if (subStatus) {
//           baseObj.sub_status_id = subStatus?.sub_status_id;
//           baseObj.sub_status_name = subStatus?.name;
//         }

//         return baseObj;
//       });
//   };

//   // --- Bulk Payload Builder ---
//   const buildBulkPayload = (leadIds: string[]) => {
//     const payloadData: any[] = [];

//     leadIds.forEach((leadId) => {
//       Object.keys(selectionMap).forEach((type) => {
//         const status = selectionMap[type]?.status;
//         const subStatus = selectionMap[type]?.subStatus;

//         if (status) {
//           payloadData.push({
//             id: leadId,
//             type_of_status: type,
//             status_id: status?.status_id,
//             status_name: status?.status_name || status?.alias_name,
//           });

//           if (subStatus) {
//             payloadData.push({
//               id: leadId,
//               type_of_status: type,
//               status_id: status?.status_id,
//               status_name: status?.status_name || status?.alias_name,
//               sub_status_id: subStatus?.sub_status_id,
//               sub_status_name: subStatus?.name,
//             });
//           }
//         }
//       });
//     });

//     return { lead_ids: leadIds, data: payloadData };
//   };

//   const handleSubmit = async () => {
//     const leadIds = getLeadIds();
//     if (!leadIds.length) {
//       showSnackBar('No leads selected', 'warning');
//       return;
//     }
//     const data_filters = tableState?.filters?.dynamicFilters || [];

//     const statusData = buildStatusData();
//     // if (!statusData.length) {
//     //   showSnackBar('Please select at least one status', 'warning');
//     //   return;
//     // }

//     try {
//       setLoading(true);

//       if (leadIds.length === 1) {
//         const singlePayload = {
//           campaign_id: campaignId,
//           leads_form_id: selectedRow?.leads_form_id || 0,
//           data_filters: data_filters,
//           data: statusData.map((item) => ({ id: leadIds[0], ...item })),
//         };

//         await leadActions.updateLeadStatusDate1({ id: leadIds[0], ...singlePayload });

//       }
//       else {
//         const bulkPayload = buildBulkPayload(leadIds);
//         await leadActions.updateLeadStatusDate1(bulkPayload);
//       }
//       showSnackBar('Status updated successfully', 'success');
//       onSuccess?.();
//       onClose();
//     } catch (err) {
//       console.error(err);
//       showSnackBar('Failed to update status', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <ModalForms
//       show={open}
//       handleClose={onClose}
//       modalHeader="Update Status"
//       size="md"
//       modalBody={
//         <Box display="flex" flexDirection="column" gap={3}>
//           {typeOptions.map((type) => {
//             const isSubType = isSubStatusType(type);
//             const statusOptions = getStatusOptions(type);
//             const subStatusOptions = getSubStatusOptions(type);

//             return (
//               <Box key={type} display="flex" flexDirection="column" gap={2}>

//                 {/* STATUS DROPDOWN */}
//                 {!isSubType && (
//                   <SearchableDropdown
//                     size="small"
//                     label={type}
//                     options={statusOptions}
//                     value={selectionMap[type]?.status || null}
//                     onChange={(value) => handleStatusChange(type, value)}
//                     getOptionLabel={(option) =>
//                       option?.alias_name || option?.status_name || ''
//                     }
//                   />
//                 )}

//                 {/* SUB STATUS DROPDOWN */}
//                 {isSubType && (
//                   <SearchableDropdown
//                     size="small"
//                     label={`${type} Sub Status`}
//                     options={subStatusOptions}
//                     value={selectionMap[type]?.subStatus || null}
//                     onChange={(value) => handleSubStatusChange(type, value)}
//                     getOptionLabel={(option) => option?.name || ''}
//                   />
//                 )}
//               </Box>
//             );
//           })}

//         </Box>
//       }
//       modalFooter={
//         <Box display="flex" justifyContent="flex-end" gap={1}>
//           <Button onClick={onClose} disabled={loading}>Cancel</Button>
//           <Button
//             variant="contained"
//             onClick={handleSubmit}
//             // disabled={loading || !Object.values(selectionMap).some((v) => v?.status)}
//           >
//             {loading ? 'Updating...' : 'Submit'}
//           </Button>
//         </Box>
//       }
//     />
//   );
// };

// export default StatusSubStatusModal;

import React, { useMemo, useState } from 'react';
import { Box, Button } from '@mui/material';
import ModalForms from '../../Shared/Modals/index.js';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { LeadFormActions } from '../../../Services/_actions/index.js';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import { useRecoilValue } from 'recoil';
import { leadsTableStateAtom } from '../../../Services/_states/index.js';

interface Props {
  open: boolean;
  onClose: () => void;
  typeOfStatusList: Record<string, any[]>;
  onSuccess?: () => void;
  selectedRow?: any;
  campaignId: string;
  dynamicFormFields: any[];
}

type SelectionState = Record<
  string,
  {
    status: any | null;
    subStatus: any | null;
  }
>;

const StatusSubStatusModal: React.FC<Props> = ({
  open,
  onClose,
  typeOfStatusList,
  selectedRow,
  onSuccess,
  campaignId,
  dynamicFormFields,
}) => {
  const leadActions = LeadFormActions();
  const { showSnackBar } = useSnackBar();
  const tableState = useRecoilValue(leadsTableStateAtom);

  const [loading, setLoading] = useState(false);
  const [selection, setSelection] = useState<SelectionState>({});

  const getLeadIds = () => {
    if (Array.isArray(selectedRow)) {
      return selectedRow.map((row) => row?.id).filter(Boolean);
    }
    return selectedRow?.id ? [selectedRow.id] : [];
  };


const statusTypes = useMemo(() => {
  return dynamicFormFields
    ?.filter(
      (f) =>
        f.key_type === 'DROPDOWN' &&
        f.statusOption === 'is_status'
    )
    .map((f) => f.key_name);
}, [dynamicFormFields]);

const buildStatusData = () => {
  const data: any[] = [];

  statusTypes.forEach((typeKey) => {
    const statusObj = selection[typeKey]?.status;
    if (!statusObj) return;

    // 1️⃣ STATUS OBJECT
    data.push({
      type_of_status: typeKey,
      status: statusObj.status_name || statusObj.alias_name,
      status_name: statusObj.status_name || statusObj.alias_name,
      status_id: statusObj.status_id,
    });

    // 2️⃣ SUB-STATUS OBJECT (SEPARATE)
    const subKey = dynamicFormFields.find(
      (f) => f.status_parent_key === typeKey
    )?.key_name;

    const subStatusObj = subKey
      ? selection[subKey]?.subStatus
      : null;

    if (subStatusObj) {
      data.push({
        type_of_status: subKey, // 👈 sub-status field key
        status_name: statusObj.status_name || statusObj.alias_name,
        status_id: statusObj.status_id,
        sub_status_id: subStatusObj.sub_status_id,
        sub_status_name: subStatusObj.name,
      });
    }
  });

  return data;
};


const buildBulkPayload = (leadIds: string[]) => {
  const payloadData: any[] = [];

  leadIds.forEach((leadId) => {
    statusTypes.forEach((typeKey) => {
      const statusObj = selection[typeKey]?.status;
      if (!statusObj) return;

      // 1️⃣ STATUS OBJECT
      payloadData.push({
        id: leadId,
        type_of_status: typeKey,
        status: statusObj.status_name || statusObj.alias_name,
        status_name: statusObj.status_name || statusObj.alias_name,
        status_id: statusObj.status_id,
      });

      // 2️⃣ SUB-STATUS OBJECT (SEPARATE)
      const subKey = dynamicFormFields.find(
        (f) => f.status_parent_key === typeKey
      )?.key_name;

      const subStatusObj = subKey
        ? selection[subKey]?.subStatus
        : null;

      if (subStatusObj) {
        payloadData.push({
          id: leadId,
          type_of_status: subKey, // 👈 sub-status field key
          status_name: statusObj.status_name || statusObj.alias_name,
          status_id: statusObj.status_id,
          sub_status_id: subStatusObj.sub_status_id,
          sub_status_name: subStatusObj.name,
        });
      }
    });
  });

  return {
    lead_ids: leadIds,
    data: payloadData,
  };
};


 const handleSubmit = async () => {
  const leadIds = getLeadIds();
  if (!leadIds.length) {
    showSnackBar('No leads selected', 'warning');
    return;
  }

  const data_filters = tableState?.filters?.dynamicFilters || [];
  const statusData = buildStatusData();

  if (!statusData.length) {
    showSnackBar('Please select at least one status', 'warning');
    return;
  }

  try {
    setLoading(true);
      if (leadIds.length === 1) {
     const singlePayload = {
          campaign_id: campaignId,
          leads_form_id: selectedRow?.leads_form_id || 0,
          data_filters: data_filters,
          data: statusData.map((item) => ({ id: leadIds[0], ...item })),
        };

        await leadActions.updateLeadStatusDate1({ id: leadIds[0], ...singlePayload });

      } else {
      await leadActions.updateLeadStatusDate1(
        buildBulkPayload(leadIds)
      );
    }

    showSnackBar('Status updated successfully', 'success');
    onSuccess?.();
    onClose();
  } catch (err) {
    console.error(err);
    showSnackBar('Failed to update status', 'error');
  } finally {
    setLoading(false);
  }
};


  const dynamicColumns =
    (dynamicFormFields?.filter((f) => f?.access_level !== 'none') ?? []).map((field) => {
      if (field.key_type === 'DROPDOWN' && field.statusOption === 'is_status') {
        const statusOptions = typeOfStatusList[field.key_name] ?? [];
        const current = selection[field.key_name]?.status ?? null;

        return (
          <SearchableDropdown
            key={field.key_name}
             label={field.alias_name}  
            options={statusOptions}
            value={current}
            labelKey="status_name"
            valueKey="status_id"
            onChange={(selected) => {
              setSelection((prev) => ({
                ...prev,
                [field.key_name]: {
                  status: selected,
                  subStatus: null,
                },
              }));
            }}
          />
        );
      }

      if (field.key_type === 'DROPDOWN' && field.statusOption === 'is_sub_status') {
        const parentKey = field.status_parent_key;

        const parentStatus =
          selection[parentKey]?.status ?? null;

        const optionsData =
          typeOfStatusList[field.key_name]?.filter(
            (s) => s.status_id === parentStatus?.status_id
          ) ?? [];

        const currentSub = selection[field.key_name]?.subStatus ?? null;

        return (
          <SearchableDropdown
            key={field.key_name}
             label={field.alias_name}  
            options={optionsData}
            value={currentSub}
            labelKey="name"
            valueKey="sub_status_id"
            disabled={!parentStatus}
            onChange={(selected) => {
              setSelection((prev) => ({
                ...prev,
                [field.key_name]: {
                  ...prev[field.key_name],
                  subStatus: selected,
                },
              }));
            }}
          />
        );
      }

    });
  return (
    <ModalForms
      show={open}
      handleClose={onClose}
      modalHeader="Update Status"
      size="md"
      modalBody={<Box display="flex" flexDirection="column" gap={2}>
        {dynamicColumns}
      </Box>}
      modalFooter={
        <Box display="flex" justifyContent="flex-end" gap={1}>
          <Button onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
          >
            Update
          </Button>
        </Box>
      }
    />
  );
};

export default StatusSubStatusModal;
